import React from 'react';
import Navigation from './Navigation';
import Footer from './Footer';
import { useLocation } from 'react-router-dom';
import SEO from '../components/SEO';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { pathname } = useLocation();
  return (
    <>
      <SEO
        title="Home | Ambi Suzanne Brenner"
        description="Creative Product Designer & Principal UX Engineer…"
        url={`${process.env.REACT_APP_SITE_URL}${pathname}`}
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Person",
          "name": "Ambi Suzanne Brenner",
          "alternateName": "Suzanne Brenner",
          "jobTitle": "Principal Frontend Engineer",
          "description": "Principal Frontend Engineer, Full Stack Developer, and UI/UX Product Designer specializing in React, Next.js, TypeScript, Tailwind CSS, and high-performance web applications.",
          "url": "https://ambisuzanne.com",
          "image": "https://ambisuzanne.com/images/profile.png",
          "homeLocation": {
            "@type": "Place",
            "address": {
              "@type": "PostalAddress",
              "addressRegion": "Nevada",
              "addressCountry": "US"
            }
          },
          "sameAs": [
            "https://www.linkedin.com/in/ambi-suzanne-brenner/",
            "https://github.com/ambisuzanne",
            "https://power3designs.com"
          ],
          "knowsAbout": [
            "React",
            "Next.js",
            "JavaScript",
            "TypeScript",
            "Node.js",
            "Python",
            "GraphQL",
            "UX Design",
            "Design Systems",
            "Tailwind CSS",
            "Frontend Engineering",
            "Full Stack Development",
            "User Interface Design",
            "Web Application Development"
          ],
          "skills": [
            "Frontend Engineering",
            "Full Stack Development",
            "UI/UX Design",
            "API Integration",
            "Performance Optimization",
            "React Component Architecture",
            "Responsive Design"
          ]
        }}
      />
      <div className="flex flex-col min-h-screen bg-[#282d39]">
        <Navigation />
        <main className="flex-1 w-full max-w-[85rem] mx-auto px-4 sm:px-6 lg:px-8 py-10 relative z-0">
          {children}
        </main>
        <div className="h-24 md:hidden"></div>
        <Footer />
      </div>
    </>
  );
};

export default Layout; 